import classNames from 'classnames';
import React from 'react';
import styles from './Form.module.scss';

interface Props {
  className?: string | null | undefined;
  children: React.ReactNode;
  onSubmit: Function;
  id?: string;
}

interface State {
  displayErrors: boolean;
}

export default class Form extends React.Component<Props, State> {
  state: State = {
    displayErrors: false,
  };

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      this.setState({ displayErrors: true });
      return;
    }

    this.setState({ displayErrors: false });

    this.props.onSubmit(event);
  };

  render() {
    const { children, className, ...rest } = this.props;
    const { displayErrors } = this.state;

    return (
      <form
        noValidate
        className={classNames(className, {
          [styles.displayErrors]: displayErrors,
        })}
        {...rest}
        onSubmit={this.handleSubmit}
      >
        {children}
      </form>
    );
  }
}
